// extracted by mini-css-extract-plugin
export default {"plus":"TeachersPage_plus__gOU5+"};